// 依頼入力画面用入力単位表示設定model
export class ReceptionEditorInputUnitDispInfo {
  // 単一入力対象が存在するか
  public get isSingleInputNeeded(): boolean {
    return this.isDepartmentInputSingle 
      || this.isManagerInputSingle
      || this.isPhaseInputSingle
      || this.isCommentInputSingle
      || this.isNextMessageInputSingle;
  }

  // 診療科入力が単一入力か
  public isDepartmentInputSingle: boolean;

  // 対応責任者が単一入力か
  public isManagerInputSingle: boolean;

  // 進捗が単一入力か
  public isPhaseInputSingle: boolean;

  // 通常コメント入力が単一入力か
  public isCommentInputSingle: boolean;

  // 伝達事項の入力が単一入力か
  public isNextMessageInputSingle: boolean;
}
